import { z } from 'zod'

const timeSeriesSchema = z.object({
  date: z.string(),
  count: z.number(),
})

const flowSchema = z.object({
  name: z.string(),
  page_id: z.string(),
  path: z.string(),
  ns: z.string(),
})

export enum SegmentType {
  AFFILIATE = 'affiliate',
  INFOPRENEUR = 'infopreneur',
}

const infopreneurSchema = z.object({
  type: z.literal(SegmentType.INFOPRENEUR),
  top_lead_collector: z.object({
    flow: flowSchema.nullish(),
    data: z.array(timeSeriesSchema),
  }),
  lead_collector: z.object({
    data: z.array(timeSeriesSchema),
  }),
  time_saved: z.object({
    data: z.array(timeSeriesSchema),
  }),
})

const affiliateSchema = z.object({
  type: z.literal(SegmentType.AFFILIATE),
  popular_link: z.object({
    url: z.string().nullish(),
    data: z.array(timeSeriesSchema),
  }),
  links_clicks: z.object({
    data: z.array(timeSeriesSchema),
  }),
  time_saved: z.object({
    data: z.array(timeSeriesSchema),
  }),
})

export const segmentInsightsSchemas = z
  .discriminatedUnion('type', [infopreneurSchema, affiliateSchema])
  .nullish()

export type SegmentInsightsSchemaType = z.infer<typeof segmentInsightsSchemas>

export type SegmentInsightsInfopreneurSchemaType = Extract<
  z.infer<typeof segmentInsightsSchemas>,
  { type: SegmentType.INFOPRENEUR }
>

export type SegmentInsightsAffiliateSchemaType = Extract<
  z.infer<typeof segmentInsightsSchemas>,
  { type: SegmentType.AFFILIATE }
>
